<template>
 <div id="template-page" class="container">
    <div class="row no-margin-bottom page-nav z-depth-1" style="min-width: 300px; width: 100%">
      <div class="col s12">
        <div class="row no-margin-bottom">
          <div class="save-chip col" :style="selectedLanguageIsTemplate ? {'background-color': '#4286f480'} : {}">
            <a class="grey-color no-padding center-align cursor-hand col clickable"
              @click="setTemplate()">
              <i class="material-icons template-icon" style="font-size: 32px">list_alt</i><br/><span>Template</span></a>
          </div>
          <div v-if="selectedLanguageIsTemplate" class="save-chip col">
            <a class="grey-color no-padding center-align cursor-hand col clickable"
              @click="addTemplateEntry()">
              <i class="material-icons new-icon" style="font-size: 32px">add_box</i><br/><span>Add template key</span></a>
          </div>
          <div class="save-chip col s2">
            <a class="grey-color no-padding center-align cursor-hand col clickable"
              @click="saveLanguage()">
              <i class="material-icons save-icon" style="font-size: 32px">save</i><br/>
                <span v-if="selectedLanguageIsTemplate">Save template</span>
                <span v-if="!selectedLanguageIsTemplate">Save translations</span>
              </a>
          </div>
          <div v-for="(cultureCode, index) in allLanguages" v-bind:key="index" class="lang-chip col" :style="activeCultureCode === cultureCode ? {'background-color': '#4286f480'} : {}">
            <a class="grey-color no-padding center-align cursor-hand col clickable"
              @click="changeLanguage(cultureCode)" >
              <img class="responsive-img" style="height: 32px" :src="require('../../../assets/country/' + cultureCode + '.png')"><br/>
              <span>{{cultureCode}}</span>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div v-if="selectedLanguageIsTemplate" class="row no-margin-bottom">
      <div class="col s12">
        <p>Do not make any changes to the template page, this is for admins only.</p>
      </div>
    </div>

    <div class="row contentrow" ref="collapsible">
      <ul v-show="selectedLanguage.length > 0" class="collapsible">
        <li v-for="(value, key, index) in distinctCategories" v-bind:key="index">
          <div class="collapsible-header collapsible-header-small" @click="resize()">{{ value }}</div>
          <div class="collapsible-body collapsible-body-small">
            <div class="row no-margin-bottom">
              <div v-for="(aValue, aKey, aIndex) in selectedLanguage" v-bind:key="aIndex">
                <div v-if="aValue.Category === value" :class="value === 'Long Texts' ? 'col s12 no-margin-top' : 'col s6 no-margin-top'">
                  <div class="row no-margin">
                    <div :class="selectedLanguageIsTemplate ? 'col s11' : 'col s12'">
                      <!-- If language is selected -->
                      <label v-if="!selectedLanguageIsTemplate" class="active" for="textarea">{{ aValue.TemplateValue }}</label>
                      <div v-if="!selectedLanguageIsTemplate" class="input-field" style="margin-top: 0px; margin-bottom 5px">
                        <textarea v-if="aValue.Key === 'countrycode'" ref="textarea" class="materialize-textarea" disabled v-model="selectedLanguage[aKey].Value"></textarea>
                        <textarea v-if="aValue.Key !== 'countrycode'" ref="textarea" class="materialize-textarea" v-model="selectedLanguage[aKey].Value"></textarea>
                      </div>

                      <!-- If template -->
                      <label v-if="selectedLanguageIsTemplate" class="active" for="textarea">{{ preKeyText }}{{ aValue.Key }}{{ afterKeyText }}</label>
                      <div v-if="selectedLanguageIsTemplate" class="input-field" style="margin-top: 0px; margin-bottom 5px">
                        <textarea ref="textarea" class="materialize-textarea" v-model="selectedLanguage[aKey].TemplateValue"></textarea>
                      </div>
                    </div>
                    <div v-if="selectedLanguageIsTemplate" class="col s1" style="padding-left: 0px; cursor: pointer" @click="removeTemplateEntry(aValue)">
                      <i style="margin-top: 22px" class="material-icons">delete_forever</i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>

    <div id="newKeyModal" class="modal">
      <div class="modal-content" style="min-height: 500px">
        <div class="row">
          <div class="input-field col s6 offset-s3 no-padding">
            <select class="browser-default" v-model="newEntry.category">
              <option disabled value="">Select category</option>
              <option v-for="(value, index) in distinctCategories" v-bind:key="index" :value="value">{{value}}</option>
            </select>
          </div>
          <div class="input-field col s6 offset-s3 no-padding">
            <input id="templateKey" type="text" class="validate" v-model="newEntry.key">
            <label for="templateKey">Key</label>
          </div>
          <div class="input-field col s6 offset-s3 no-padding">
            <input id="templateDescription" type="text" class="validate" v-model="newEntry.description">
            <label for="templateDescription">Description</label>
          </div>
          <div class="col s6 offset-s3">
            <div class="row">
              <div class="col s4">
                Category:<br/>
                Key:<br/>
                Description:
              </div>
              <div class="col s8">
                {{newEntry.category}}<br/>
                {{preKeyText}}{{newEntry.key}}{{afterKeyText}}<br/>
                {{newEntry.description}}
              </div>
            </div>
          </div>
          <div class="input-field col s6 offset-s3">
            <div class="row">
              <div class="right-align">
                <a class="waves-effect waves-light btn right-align" @click="addNewEntry()">Save</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="removeKeyModal" class="modal">
      <div class="modal-content">
        <h4>{{removeEntry.key}}</h4>
        <p>Are you sure you want to remove the key? This process cannot be undone and might cause website translations to become corrupt</p>
      </div>
      <div class="modal-footer">
        <a class="modal-close waves-effect waves-green btn-flat">Cancel</a>
        <a class="modal-close waves-effect waves-green btn-flat" @click="confirmRemoveTemplateEntry()">Yes i'm sure</a>
      </div>
    </div>

    <div v-if="spinnerLoading">
      <spinner :text="spinnerText"></spinner>
    </div>
  </div>
</template>

<script>
import languageService from '../../../services/api/LanguageService.js'
import spinner from '../../../components/Spinner'
import translations from '../../Translation'

var newKeyModal = null
var removeKeyModal = null

export default {
  data () {
    return {
      preKeyText: '{{ $t(\'',
      afterKeyText: '\') }}',
      allLanguages: [],
      allTranslations: [],
      selectedLanguage: [],
      selectedLanguageIsTemplate: false,
      distinctCategories: [],
      activeCultureCode: undefined,
      spinnerLoading: false,
      spinnerText: 'loading...',
      newEntry: {
        category: undefined,
        key: undefined,
        description: undefined
      },
      removeEntry: {
        category: undefined,
        key: undefined,
        description: undefined
      }
    }
  },
  components: {
    Spinner: spinner
  },
  computed: {
  },
  beforeCreate () {
    /* Get all languages */
    languageService.getLanguages()
      .then(response => {
        response.data.forEach(element => {
          this.allLanguages.push(element.Translation)
        })
        this.spinnerLoading = false
      })
      .catch(e => {
        this.spinnerLoading = false
        console.log(e)
      })

    /* Get all translations */
    languageService.getTranslations()
      .then(response => {
        /* Set translations */
        this.allTranslations = response.data
        /* Set unique categories */
        // var test = response.data.map(item => item.Category)
        // console.log(test)
        this.distinctCategories = response.data.map(item => item.Category)
          .filter((value, index, self) => self.indexOf(value) === index).sort()
        this.spinnerLoading = false
      })
      .catch(e => {
        this.spinnerLoading = false
        console.log(e)
      })
  },
  mounted: function () {
    this.spinnerLoading = true
    var elem = document.querySelector('.collapsible')
    M.Collapsible.init(elem)

    var elems = document.querySelectorAll('select')
    M.FormSelect.init(elems)

    var newKeyModalElems = document.querySelector('#newKeyModal')
    newKeyModal = M.Modal.init(newKeyModalElems)

    var removeKeyModalElems = document.querySelector('#removeKeyModal')
    removeKeyModal = M.Modal.init(removeKeyModalElems)
    this.spinnerLoading = false
  },
  methods: {
    clearObjectsAndReloadLanguage () {
      for (const prop of Object.getOwnPropertyNames(this.newEntry)) {
        delete this.newEntry[prop]
      }

      for (const prop of Object.getOwnPropertyNames(this.removeEntry)) {
        delete this.removeEntry[prop]
      }
    },
    reloadActiveLanguage () {
      var language = localStorage.getItem('locale')
      translations.setLanguage(language)
    },
    loadTranslations () {
      /* Get all translations */
      languageService.getTranslations()
        .then(response => {
        /* Set translations */
          this.allTranslations = response.data
          /* Set unique categories */
          this.distinctCategories = response.data.map(item => item.Category)
            .filter((value, index, self) => self.indexOf(value) === index).sort()
          this.spinnerLoading = false
        })
        .catch(e => {
          this.spinnerLoading = false
          console.log(e)
        })
    },
    addNewEntry () {
      if (this.newEntry.category &&
      this.newEntry.key &&
      this.newEntry.description) {
        this.spinnerLoading = true
        this.spinnerText = 'saving...'
        languageService.postNewTemplateEntry(this.newEntry)
          .then(response => {
            this.$notify({
              group: 'alerts',
              type: 'success',
              title: 'Translations',
              text: 'Saved changes',
              duration: 10000,
              speed: 1000
            })
            this.clearObjects()
            this.loadTranslations()
            this.setTemplate()
            this.reloadActiveLanguage()
            this.spinnerLoading = false
          })
          .catch(e => {
            this.spinnerLoading = false
            console.log(e)
          })
      }
    },
    removeTemplateEntry (key) {
      this.removeEntry.key = key.Key
      removeKeyModal.open()
    },
    addTemplateEntry () {
      newKeyModal.open()
    },
    confirmRemoveTemplateEntry () {
      this.spinnerText = 'removing data...'
      this.spinnerLoading = true

      languageService.removeTemplateKey(this.removeEntry)
        .then(response => {
          this.$notify({
            group: 'alerts',
            type: 'success',
            title: 'Translations',
            text: 'Removed key',
            duration: 10000,
            speed: 1000
          })
          this.clearObjects()
          this.loadTranslations()
          this.setTemplate()
          this.reloadActiveLanguage()
          this.spinnerLoading = false
        })
        .catch(e => {
          this.spinnerLoading = false
          console.log(e)
        })
    },
    setTemplate () {
      this.selectedLanguageIsTemplate = true
      this.activeCultureCode = undefined

      this.spinnerLoading = true
      languageService.getTemplate()
        .then(response => {
          this.selectedLanguage = response.data
          this.spinnerLoading = false
        })
        .catch(e => {
          console.log(e)
          this.spinnerLoading = false
        })
    },
    saveLanguage () {
      this.spinnerText = 'saving...'

      if (!this.selectedLanguageIsTemplate) {
        this.spinnerLoading = true
        languageService.postTranslations(this.allTranslations)
          .then(response => {
            this.$notify({
              group: 'alerts',
              type: 'success',
              title: 'Translations',
              text: 'Saved changes',
              duration: 10000,
              speed: 1000
            })
            this.reloadActiveLanguage()
            this.spinnerLoading = false
          })
          .catch(e => {
            console.log(e)
          })
      } else {
        this.spinnerLoading = true
        languageService.postTemplate(this.selectedLanguage)
          .then(response => {
            this.$notify({
              group: 'alerts',
              type: 'success',
              title: 'Template',
              text: 'Saved changes',
              duration: 10000,
              speed: 1000
            })
            this.reloadActiveLanguage()
            this.spinnerLoading = false
          })
          .catch(e => {
            console.log(e)
          })
      }
    },
    resize () {
      this.$nextTick(() => {
        for (var i = 0; i < this.$refs.textarea.length; i++) {
          M.textareaAutoResize(this.$refs.textarea[i])
        }
      })
    },
    changeLanguage (selectedLanguageCultureCode) {
      this.spinnerText = 'loading...'

      this.selectedLanguageIsTemplate = false
      this.activeCultureCode = selectedLanguageCultureCode
      if (selectedLanguageCultureCode !== undefined) {
        this.selectedLanguage = this.allTranslations.filter(function (element) {
          return element.CultureCode === selectedLanguageCultureCode
        })
      }
    }
  }
}

</script>

<style>
  #template-page {
    height: calc(100vh - 65px);
    overflow-y: scroll;
    overflow-x: hidden;
    line-height: 1;
  }
  .showPath {
    color: rgba(130, 130, 130, 0.5);
    cursor: pointer;
  }
  .showAlert {
    color: rgba(177, 0, 0, 0.5);
  }
  .showOke {
    color: rgba(0, 177, 0, 0.5)
  }
  .input-field {
    margin-bottom: 0px;
  }
  textarea {
    min-height: 1rem;
  }
  textarea.materialize-textarea {
    min-height: 1rem;
    padding: 0px;
    font-size: 14px;
    height: 30px;
  }
  .contentrow {
    width: 100%;
  }
  .page-nav {
    margin-top: 3px;
    padding: 5px;
    overflow-y: hidden;
    background-color: white;
    z-index: 1;
  }
  .collapsible-header-small {
    padding-top: 5px;
    padding-bottom: 5px;
  }
  .collapsible-body-small {
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .small-font {
    font-size: 14px;
  }
  .languagepage {
    overflow-y: scroll;
  }
  .lang-chip {
    height: 55px;
    display: inline-block;
    padding-right: 11.25px;
    line-height: 1;
  }
  .save-chip {
    height: 55px;
    display: inline-block;
    padding-right: 11.25px;
    line-height: 1;
  }
  .new-chip {
    height: 55px;
    display: inline-block;
    padding-right: 11.25px;
    line-height: 1;
  }
  .template-icon {
    color:darkslateblue;
  }
  .new-icon {
    color:darkgreen;
  }
  .save-icon {
    color: darkblue;
  }
</style>



// WEBPACK FOOTER //
// src/i18n/lang/template/langtemplate.vue